module.exports = __webpack_public_path__ + "img/guest_default.ef94b9c8.png";